import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ResultsFiltersButtons from '@Containers/ResultsFilters/ResultsFiltersComponents/ResultsFiltersButtons';
import ListOfFilters from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters';
import Drawer from '@Components/Drawer/Drawer';

import './ResultsFilters.scss';

export default function ResultsFilters({ className, open, setOpenFilters, openHeatmapIndicator, heatmapFullScreenModeIndicator }) {
  const state = open ? 'open' : 'close';

  return (
    <Drawer isOpen={open} setIsOpen={setOpenFilters} header="Filters">
      <section
        className={classnames(
          'results-filters',
          'u-els-padding-top',
          'u-els-padding-bottom',
          `results-filters-${state}`,
          {
            [heatmapFullScreenModeIndicator ? 'results-filters-heatmap-view-full-screen' : 'results-filters-heatmap-view']:
              openHeatmapIndicator,
          },
          className
        )}
        aria-label="Refine results">
        <ListOfFilters />
      </section>
      <ResultsFiltersButtons />
    </Drawer>
  );
}

ResultsFilters.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpenFilters: PropTypes.func.isRequired,
  openHeatmapIndicator: PropTypes.bool.isRequired,
  heatmapFullScreenModeIndicator: PropTypes.bool,
};
